import {isMuiltLanguagesJson, createMuiltLanguagesJson} from "@/components/widgets/nav/repeatNumber.js";

export function washData_nav(walkedNode) {
  if(walkedNode.data.attribute.repeatNumber_value){
    if(!isMuiltLanguagesJson(walkedNode.data.attribute.repeatNumber_value)){
      walkedNode.data.attribute.repeatNumber_value = createMuiltLanguagesJson(walkedNode.data.attribute.repeatNumber_value)
    }
  }



}
